import logo from "./img/arkodomo-logo-no-background.png";
import React from "react";
import { Image } from 'react-bootstrap';

type Props = { className?: string };

function LogoImage({ className }: Props) {
  return (
    <Image src={logo} alt={"Arkodomo"} fluid className={className} />
  );
}

export default LogoImage;
